import { http } from './http';
import { apiHelper } from 'shared';

const controllerName = 'analytics-reports';

class AnalyticsReports {
  async getUsingQueryFilter(queryFilter) {
    let queryString = '';
    queryString = apiHelper.composeQueryString({ name: queryFilter });

    const response = await http.get(`/${controllerName}${queryString}`);
    const items = response.data && response.data.items;

    return items;
  }

  get(paging, sorting, filters) {
    let queryString = '';
    queryString = apiHelper.composeQueryString({ ...paging, ...sorting, ...filters });

    return http.get(`/${controllerName}/${queryString}`);
  }

  getById(id) {
    return http.get(`/${controllerName}/${id}`);
  }

  create(report) {
    return http.post(`/${controllerName}`, report);
  }

  delete(id) {
    return http.delete(`/${controllerName}/${id}`);
  }

  update(id, report) {
    return http.put(`/${controllerName}/${id}`, report);
  }

  sendByMail(request) {
    return http.post(`/${controllerName}/mail`, request);
  }
}

export const analyticsReports = new AnalyticsReports();
